<ng-container [ngSwitch]="outputInfoStore.state().output.type">
  <h3-checkbox-output *ngSwitchCase="'CheckboxOutput'"></h3-checkbox-output>
  <h3-dropdown-output *ngSwitchCase="'DropdownOutput'"></h3-dropdown-output>
  <h3-multilevel-menu-output
    *ngSwitchCase="'MultilevelMenuOutput'"
  ></h3-multilevel-menu-output>
  <h3-radio-buttons-output
    *ngSwitchCase="'RadioOutput'"
  ></h3-radio-buttons-output>
  <h3-tag-library-output
    *ngSwitchCase="'TagLibraryOutput'"
  ></h3-tag-library-output>
  <h3-textfield-output *ngSwitchCase="'TextfieldOutput'"></h3-textfield-output>
  <h3-text-area-output *ngSwitchCase="'TextAreaOutput'"></h3-text-area-output>
</ng-container>
